/* Jeff Hamilton wholesale: order sheet, catalog, quick order, CSV import, reorder, application form.
   Prices shown here are for display. The wholesale team sets final prices on the Shopify invoice. */
(function () {
  'use strict';

  var money = function (cents) {
    var n = Number(cents) / 100;
    if (!isFinite(n)) return '—';
    return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var store = {
    get: function (area, key, fallback) {
      try { var v = window[area].getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    },
    set: function (area, key, val) {
      try { window[area].setItem(key, JSON.stringify(val)); return true; } catch (e) { return false; }
    },
    del: function (area, key) { try { window[area].removeItem(key); } catch (e) {} }
  };
  var track = function (name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('wholesale_' + name, data || {}); } catch (e) {}
  };
  var makeRef = function (prefix) {
    var d = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var rand = Math.random().toString(36).slice(2, 6).toUpperCase();
    return prefix + '-' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + '-' + rand;
  };
  var toastEl;
  var toast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  };
  var fetchJSON = function (url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  };
  var groupLabel = function (g) { return g && g !== '~' ? g : ''; };

  /* ---------- Customer id (scopes stored data to the logged-in buyer) ---------- */
  var cfgEl = document.getElementById('WhConfig');
  var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var cidEl = document.querySelector('[data-wh-customer]');
  var cid = cfg.customerId || (cidEl && cidEl.dataset.whCustomer) ||
    (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId) || 'guest';
  var KEY = 'jhwh:sheet:' + cid;
  var LISTS = 'jhwh:lists:' + cid;
  var HISTORY = 'jhwh:history:' + cid;

  /* ---------- Sheet store ---------- */
  var Sheet = {
    data: null,
    load: function () {
      this.data = store.get('localStorage', KEY, null) || { lines: [], fields: {}, ref: makeRef('WO') };
      if (!this.data.ref) this.data.ref = makeRef('WO');
      return this.data;
    },
    save: function () {
      this.data.updated = Date.now();
      if (!store.set('localStorage', KEY, this.data)) toast('Your browser blocked saving. Keep this tab open until you send the request.');
      updateCounts();
    },
    find: function (id) { return this.data.lines.find(function (l) { return String(l.id) === String(id); }); },
    add: function (line, mode) {
      var ex = this.find(line.id);
      if (ex) {
        ex.qty = mode === 'set' ? line.qty : ex.qty + line.qty;
        ['unit', 'retail', 'state', 'available', 'sku', 'image'].forEach(function (k) { if (line[k] != null) ex[k] = line[k]; });
      } else {
        this.data.lines.push(line);
      }
    },
    units: function () { return this.data.lines.reduce(function (s, l) { return s + l.qty; }, 0); },
    clear: function () { this.data = { lines: [], fields: {}, ref: makeRef('WO') }; this.save(); }
  };
  Sheet.load();

  function updateCounts() {
    var units = Sheet.units();
    document.querySelectorAll('[data-wh-sheet-count]').forEach(function (el) {
      el.textContent = units;
      el.hidden = units === 0;
    });
    var bar = document.querySelector('[data-wh-sheetbar]');
    if (bar) {
      bar.hidden = units === 0;
      var styles = new Set(Sheet.data.lines.map(function (l) { return l.handle; })).size;
      var sub = Sheet.data.lines.reduce(function (s, l) { return s + l.qty * l.unit; }, 0);
      var t = bar.querySelector('[data-wh-sheetbar-text]');
      if (t) t.textContent = 'Order sheet: ' + units + ' units · ' + styles + ' style' + (styles === 1 ? '' : 's') + ' · ' + money(sub) + ' wholesale';
    }
  }

  /* ---------- Focus helpers ---------- */
  document.querySelectorAll('[data-wh-focus]').forEach(function (el) { setTimeout(function () { el.focus(); el.scrollIntoView({ block: 'center' }); }, 60); });
  document.querySelectorAll('[data-wh-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ---------- Catalog rows ---------- */
  var minStyle = cfg.minPerStyle || Number((document.querySelector('[data-wh-min-style]') || { dataset: {} }).dataset.whMinStyle) || 6;

  function readRow(row) {
    var lines = [], errors = [];
    row.querySelectorAll('[data-wh-qty]').forEach(function (inp) {
      var raw = inp.value.trim();
      inp.removeAttribute('aria-invalid');
      if (raw === '') return;
      var q = Number(raw);
      if (!Number.isInteger(q) || q < 0) {
        errors.push((inp.dataset.size || 'Size') + ': whole numbers only');
        inp.setAttribute('aria-invalid', 'true');
        return;
      }
      if (q === 0) return;
      if (inp.dataset.state === 'off') return;
      lines.push({
        id: Number(inp.dataset.variantId), handle: row.dataset.handle, product: row.dataset.title, image: row.dataset.image,
        variant: inp.dataset.variant, size: inp.dataset.size, group: groupLabel(inp.dataset.group), sku: inp.dataset.sku,
        qty: q, unit: Number(inp.dataset.unit), retail: Number(inp.dataset.retail), state: inp.dataset.state,
        available: inp.dataset.available === '' ? null : Number(inp.dataset.available)
      });
    });
    return { lines: lines, errors: errors };
  }

  document.querySelectorAll('[data-wh-product]').forEach(function (row) {
    var msg = row.querySelector('[data-wh-row-msg]');
    var say = function (text, kind) { msg.textContent = text; msg.className = 'wh-product__msg' + (kind ? ' is-' + kind : ''); };
    var add = function () {
      var r = readRow(row);
      if (r.errors.length) { say(r.errors.join('. '), 'err'); return; }
      if (!r.lines.length) { say('Enter a quantity for at least one size.', 'err'); return; }
      r.lines.forEach(function (l) { Sheet.add(l); });
      Sheet.save();
      var styleUnits = Sheet.data.lines.filter(function (l) { return l.handle === row.dataset.handle; }).reduce(function (s, l) { return s + l.qty; }, 0);
      var added = r.lines.reduce(function (s, l) { return s + l.qty; }, 0);
      var over = r.lines.filter(function (l) { return l.available != null && l.available > 0 && l.qty > l.available; });
      var text = 'Added ' + added + ' unit' + (added === 1 ? '' : 's') + '. This style now has ' + styleUnits + ' on your sheet';
      text += styleUnits < minStyle ? ' (minimum ' + minStyle + ').' : '.';
      if (over.length) text += ' Some sizes exceed current stock; we will confirm availability.';
      say(text, styleUnits < minStyle ? '' : 'ok');
      row.querySelectorAll('[data-wh-qty]').forEach(function (i) { i.value = ''; });
      track('add_to_sheet', { handle: row.dataset.handle, units: added });
    };
    row.querySelector('[data-wh-add]').addEventListener('click', add);
    row.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-wh-qty]')) { e.preventDefault(); add(); } });
    row.querySelector('[data-wh-fill-run]').addEventListener('click', function () {
      row.querySelectorAll('[data-wh-qty]').forEach(function (i) { if (i.dataset.state !== 'off') i.value = String((Number(i.value) || 0) + 1); });
      say('One of each available size entered. Adjust, then add to your sheet.');
    });
    row.querySelector('[data-wh-clear-row]').addEventListener('click', function () {
      row.querySelectorAll('[data-wh-qty]').forEach(function (i) { i.value = ''; i.removeAttribute('aria-invalid'); });
      say('');
    });
  });

  /* ---------- Product data (server-checked price and stock) ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetchJSON('/products/' + encodeURIComponent(handle) + '?view=wholesale-json').then(function (d) {
        if (!d.ok) throw new Error(d.error || 'not_authorized');
        return d.product;
      });
    }
    return productCache[handle];
  }
  function searchProducts(q) {
    return fetchJSON('/search?type=product&view=wholesale-json&q=' + encodeURIComponent(q)).then(function (d) {
      if (!d.ok) throw new Error(d.error || 'not_authorized');
      return d.results || [];
    });
  }
  function lineFromVariant(p, v, qty) {
    return {
      id: v.id, handle: p.handle, product: p.title, image: p.image, variant: v.title, size: v.size, group: v.group,
      sku: v.sku, qty: qty, unit: v.unit, retail: v.retail, state: v.state, available: v.available
    };
  }

  /* ---------- Order sheet page ---------- */
  var sheetEl = document.querySelector('[data-wh-sheet]');
  if (sheetEl) initSheet(sheetEl);

  function initSheet(root) {
    var form = root.closest('form');
    var linesEl = root.querySelector('[data-wh-lines]');
    var changesEl = root.querySelector('[data-wh-changes]');
    var checksEl = root.querySelector('[data-wh-checks]');
    var errBox = root.querySelector('[data-wh-submit-errors]');
    var submitBtn = root.querySelector('[data-wh-submit-order]');
    var emptyHTML = linesEl.innerHTML;
    var refreshState = 'idle';
    var productVariants = {};

    // Posted successfully: archive the request, clear the sheet.
    if (root.dataset.whPosted === 'true') {
      var pending = store.get('sessionStorage', 'jhwh:pending-order', null);
      var refEl = document.querySelector('[data-wh-req-ref]');
      if (pending) {
        if (refEl) refEl.textContent = pending.ref;
        var hist = store.get('localStorage', HISTORY, []);
        if (!hist.some(function (h) { return h.ref === pending.ref; })) {
          hist.unshift(pending);
          store.set('localStorage', HISTORY, hist.slice(0, 25));
          track('order_request_submitted', { ref: pending.ref, units: pending.units, subtotal: pending.subtotal / 100, type: cfg.orderType });
        }
        store.del('sessionStorage', 'jhwh:pending-order');
        if (Sheet.data.ref === pending.ref) Sheet.clear();
      }
    }

    // Persisted request fields
    root.querySelectorAll('[data-wh-persist]').forEach(function (el) {
      var k = el.dataset.whPersist;
      var saved = Sheet.data.fields[k];
      if (saved) {
        if (el.tagName !== 'SELECT' || [].some.call(el.options, function (o) { return o.value === saved; })) el.value = saved;
      }
      el.addEventListener('input', function () { Sheet.data.fields[k] = el.value; Sheet.save(); });
      el.addEventListener('change', function () { Sheet.data.fields[k] = el.value; Sheet.save(); });
    });
    var dateEl = root.querySelector('[data-wh-min-date]');
    if (dateEl) { var t = new Date(Date.now() + 86400000); dateEl.min = t.toISOString().slice(0, 10); }

    function totals() {
      var lines = Sheet.data.lines;
      var byStyle = {};
      lines.forEach(function (l) { (byStyle[l.handle] = byStyle[l.handle] || []).push(l); });
      return {
        units: Sheet.units(),
        styles: Object.keys(byStyle).length,
        byStyle: byStyle,
        subtotal: lines.reduce(function (s, l) { return s + l.qty * l.unit; }, 0),
        retail: lines.reduce(function (s, l) { return s + l.qty * l.retail; }, 0)
      };
    }

    function checks(t) {
      var list = [];
      var min = cfg.orderMin || 0;
      list.push({ ok: t.subtotal >= min, level: 'err', text: (cfg.orderType === 'opening' ? 'Opening order' : 'Reorder') + ' minimum ' + money(min).replace('.00', '') + (t.subtotal < min ? ' (' + money(min - t.subtotal) + ' to go)' : '') });
      list.push({ ok: t.units >= cfg.minUnits, level: 'err', text: 'At least ' + cfg.minUnits + ' units' + (t.units < cfg.minUnits ? ' (' + (cfg.minUnits - t.units) + ' to go)' : '') });
      var short = Object.keys(t.byStyle).filter(function (h) { return t.byStyle[h].reduce(function (s, l) { return s + l.qty; }, 0) < cfg.minPerStyle; });
      list.push({ ok: t.styles > 0 && short.length === 0, level: 'err', text: 'At least ' + cfg.minPerStyle + ' units per style' + (short.length ? ' (' + short.length + ' style' + (short.length === 1 ? '' : 's') + ' short)' : '') });
      var off = Sheet.data.lines.filter(function (l) { return l.state === 'off'; });
      if (off.length) list.push({ ok: false, level: 'err', text: off.length + ' size' + (off.length === 1 ? ' is' : 's are') + ' no longer available. Remove ' + (off.length === 1 ? 'it' : 'them') + ' to continue' });
      var partial = Object.keys(t.byStyle).filter(function (h) {
        var pv = productVariants[h]; if (!pv) return false;
        var groups = {};
        t.byStyle[h].forEach(function (l) { groups[l.group || ''] = true; });
        return Object.keys(groups).some(function (g) {
          var sizes = pv.filter(function (v) { return (v.group || '') === g && v.state !== 'off'; }).map(function (v) { return v.id; });
          return sizes.some(function (id) { return !Sheet.find(id); });
        });
      });
      if (partial.length) list.push({ ok: false, level: 'warn', text: partial.length + ' style' + (partial.length === 1 ? ' isn\'t a' : 's aren\'t') + ' full size run. We ask for a full run where available' });
      if (refreshState === 'failed') list.push({ ok: false, level: 'warn', text: 'We couldn\'t recheck stock and prices just now. We\'ll confirm on your invoice' });
      if (refreshState === 'running') list.push({ ok: false, level: 'warn', text: 'Checking current stock and prices…' });
      return list;
    }

    function render() {
      var t = totals();
      var lines = Sheet.data.lines;
      if (!lines.length) {
        linesEl.innerHTML = emptyHTML;
      } else {
        var html = '<div class="wh-table-wrap"><table class="wh-table"><caption class="visually-hidden-wh">Order sheet lines</caption><thead><tr><th scope="col">Size</th><th scope="col">SKU</th><th scope="col">Availability</th><th scope="col">Quantity</th><th scope="col" class="num">Unit (wholesale)</th><th scope="col" class="num">Line total</th><th scope="col"><span class="visually-hidden-wh">Remove</span></th></tr></thead>';
        Object.keys(t.byStyle).forEach(function (h) {
          var ls = t.byStyle[h];
          var su = ls.reduce(function (s, l) { return s + l.qty; }, 0);
          var st = ls.reduce(function (s, l) { return s + l.qty * l.unit; }, 0);
          html += '<tbody><tr class="wh-style-row"><td colspan="5"><a href="/products/' + esc(h) + '" target="_blank" rel="noopener">' + esc(ls[0].product) + '</a> <small>· ' + su + ' unit' + (su === 1 ? '' : 's') + (su < cfg.minPerStyle ? ' · <span style="color:var(--wh-err)">minimum ' + cfg.minPerStyle + ' per style</span>' : '') + '</small></td><td class="num">' + money(st) + '</td><td><button type="button" class="wh-link-btn" data-wh-remove-style="' + esc(h) + '">Remove style</button></td></tr>';
          ls.forEach(function (l) {
            var avail = l.state === 'stock' ? '<span class="wh-pill wh-pill--stock">' + (l.available != null ? l.available + ' in stock' : 'In stock') + '</span>'
              : l.state === 'mto' ? '<span class="wh-pill wh-pill--mto">Made to order</span>' : '<span class="wh-pill wh-pill--none">Sold out</span>';
            var flags = '';
            if (l.state === 'stock' && l.available != null && l.qty > l.available) flags += '<span class="wh-line-flag is-warn">Only ' + l.available + ' in stock. The rest may be made to order; we\'ll confirm.</span>';
            if (l.state === 'off') flags += '<span class="wh-line-flag is-err">No longer available. Please remove.</span>';
            if (l.changed) flags += '<span class="wh-line-flag is-warn">' + esc(l.changed) + '</span>';
            var label = (l.group ? esc(l.group) + ' / ' : '') + esc(l.size || l.variant);
            html += '<tr><td>' + label + '</td><td>' + esc(l.sku || '—') + '</td><td>' + avail + '</td><td><div class="wh-qty"><button type="button" aria-label="Decrease ' + label + '" data-wh-step="-1" data-id="' + l.id + '">−</button><input type="number" min="0" step="1" inputmode="numeric" value="' + l.qty + '" aria-label="Quantity, ' + esc(l.product) + ' ' + label + '" data-wh-line-qty data-id="' + l.id + '"><button type="button" aria-label="Increase ' + label + '" data-wh-step="1" data-id="' + l.id + '">+</button></div>' + flags + '</td><td class="num">' + money(l.unit) + '<br><small class="wh-muted">Retail ' + money(l.retail) + '</small></td><td class="num">' + money(l.unit * l.qty) + '</td><td><button type="button" class="wh-link-btn" data-wh-remove="' + l.id + '" aria-label="Remove ' + esc(l.product) + ' ' + label + '">Remove</button></td></tr>';
          });
          html += '</tbody>';
        });
        html += '<tfoot><tr><td colspan="3">Total</td><td>' + t.units + ' units</td><td></td><td class="num">' + money(t.subtotal) + '</td><td></td></tr></tfoot></table></div>';
        linesEl.innerHTML = html;
      }
      // Summary
      var set = function (k, v) { var el = root.querySelector('[data-wh-sum="' + k + '"]'); if (el) el.textContent = v; };
      set('styles', t.styles); set('units', t.units);
      set('retail', t.units ? money(t.retail) : '—'); set('subtotal', t.units ? money(t.subtotal) : '—');
      var meter = root.querySelector('[data-wh-meter]');
      if (meter) meter.style.width = Math.min(100, cfg.orderMin ? (t.subtotal / cfg.orderMin) * 100 : 100) + '%';
      var cs = checks(t);
      checksEl.innerHTML = cs.map(function (c) { return '<li class="' + (c.ok ? 'is-ok' : c.level === 'warn' ? 'is-warn' : t.units ? 'is-err' : '') + '">' + esc(c.text) + '</li>'; }).join('');
      var blocking = cs.filter(function (c) { return !c.ok && c.level === 'err'; });
      submitBtn.setAttribute('aria-disabled', blocking.length ? 'true' : 'false');
      updateCounts();
    }

    function setQty(id, q) {
      var l = Sheet.find(id); if (!l) return;
      q = Math.max(0, Math.floor(Number(q) || 0));
      if (q === 0) Sheet.data.lines = Sheet.data.lines.filter(function (x) { return x !== l; });
      else l.qty = q;
      Sheet.save();
    }

    linesEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.whStep) {
        var l = Sheet.find(b.dataset.id); if (!l) return;
        setQty(l.id, l.qty + Number(b.dataset.whStep));
        render();
        var inp = linesEl.querySelector('[data-wh-line-qty][data-id="' + b.dataset.id + '"]');
        var again = linesEl.querySelector('[data-wh-step="' + b.dataset.whStep + '"][data-id="' + b.dataset.id + '"]');
        (again || inp || linesEl).focus();
      } else if (b.dataset.whRemove) {
        var gone = Sheet.find(b.dataset.whRemove);
        setQty(b.dataset.whRemove, 0); render();
        toast('Removed ' + (gone ? gone.product + ' ' + (gone.size || '') : 'line'));
      } else if (b.dataset.whRemoveStyle) {
        Sheet.data.lines = Sheet.data.lines.filter(function (x) { return x.handle !== b.dataset.whRemoveStyle; });
        Sheet.save(); render(); toast('Style removed');
      }
    });
    linesEl.addEventListener('change', function (e) {
      if (!e.target.matches('[data-wh-line-qty]')) return;
      var v = e.target.value.trim();
      if (!/^\d+$/.test(v)) { e.target.setAttribute('aria-invalid', 'true'); toast('Quantities must be whole numbers'); return; }
      setQty(e.target.dataset.id, v); render();
      var again = linesEl.querySelector('[data-wh-line-qty][data-id="' + e.target.dataset.id + '"]');
      if (again) again.focus();
    });

    root.querySelector('[data-wh-clear-sheet]').addEventListener('click', function () {
      if (!Sheet.data.lines.length) return;
      if (window.confirm('Clear every line from your order sheet?')) { Sheet.clear(); render(); toast('Order sheet cleared'); }
    });

    // Recheck price and stock with Shopify for every style on the sheet
    function refresh() {
      var handles = Array.from(new Set(Sheet.data.lines.map(function (l) { return l.handle; })));
      if (!handles.length) { refreshState = 'idle'; render(); return Promise.resolve(); }
      refreshState = 'running'; render();
      var notes = [];
      var queue = handles.slice();
      var failed = false;
      var worker = function () {
        var h = queue.shift();
        if (!h) return Promise.resolve();
        return getProduct(h).then(function (p) {
          productVariants[h] = p.variants;
          Sheet.data.lines.filter(function (l) { return l.handle === h; }).forEach(function (l) {
            var v = p.variants.find(function (x) { return String(x.id) === String(l.id); });
            var was = l.origUnit != null ? l.origUnit : l.unit;
            if (!v || p.excluded) { l.state = 'off'; l.changed = 'This size is no longer offered.'; notes.push(l.product + ' ' + (l.size || '') + ' is no longer offered'); return; }
            if (v.unit !== was) {
              l.changed = 'Price ' + (v.unit > was ? 'up' : 'down') + ' from ' + money(was) + ' to ' + money(v.unit) + (l.origUnit != null ? ' since ' + (l.source || 'your last order') : '') + '.';
              notes.push(l.product + ' ' + (l.size || '') + ': ' + money(was) + ' → ' + money(v.unit));
            } else if (l.origUnit == null) { l.changed = ''; }
            if (l.state !== v.state && v.state === 'off') notes.push(l.product + ' ' + (l.size || '') + ' is sold out');
            if (l.state === 'stock' && v.state === 'mto') notes.push(l.product + ' ' + (l.size || '') + ' is now made to order');
            l.unit = v.unit; l.retail = v.retail; l.state = v.state; l.available = v.available; l.sku = v.sku;
            l.product = p.title; l.size = v.size; l.group = v.group; l.variant = v.title;
          });
          delete productCache[h];
        }).catch(function () { failed = true; }).then(worker);
      };
      return Promise.all([worker(), worker(), worker()]).then(function () {
        refreshState = failed ? 'failed' : 'done';
        Sheet.data.lines.forEach(function (l) { if (l.origUnit != null && l.unit === l.origUnit && l.state !== 'off') l.changed = ''; });
        Sheet.save();
        if (notes.length) {
          changesEl.hidden = false;
          changesEl.innerHTML = '<p><strong>Some lines changed since they were added:</strong></p><ul style="margin:0;padding-left:18px">' + notes.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul>';
        } else { changesEl.hidden = true; }
        render();
      });
    }

    // Quick search
    var qInput = root.querySelector('[data-wh-quick]');
    var qResults = root.querySelector('[data-wh-quick-results]');
    var qTimer, qSeq = 0;
    qInput.addEventListener('input', function () {
      clearTimeout(qTimer);
      var q = qInput.value.trim();
      if (q.length < 2) { qResults.innerHTML = ''; return; }
      qTimer = setTimeout(function () {
        var seq = ++qSeq;
        qResults.innerHTML = '<p class="wh-muted" style="padding:12px">Searching…</p>';
        searchProducts(q).then(function (rs) {
          if (seq !== qSeq) return;
          rs = rs.filter(function (p) { return !p.excluded; });
          if (!rs.length) { qResults.innerHTML = '<p style="padding:12px">No styles match “' + esc(q) + '”. Try a team name or the start of a SKU.</p>'; return; }
          var ql = q.toLowerCase();
          qResults.innerHTML = rs.map(function (p) {
            var groups = {};
            p.variants.forEach(function (v) { (groups[v.group || ''] = groups[v.group || ''] || []).push(v); });
            var unitMin = Math.min.apply(null, p.variants.map(function (v) { return v.unit; }));
            return '<div class="wh-result" data-wh-qr="' + esc(p.handle) + '"><img src="' + esc(p.image || '') + '" alt="" loading="lazy" width="48" height="64"><div><div class="wh-result__title">' + esc(p.title) + '</div><div class="wh-result__meta">From ' + money(unitMin) + ' per unit</div>' +
              Object.keys(groups).map(function (g) {
                return (g ? '<p class="wh-group__name" style="margin:8px 0 4px">' + esc(g) + '</p>' : '') + '<div class="wh-sizes" style="margin-top:6px">' + groups[g].map(function (v) {
                  var hit = v.sku && v.sku.toLowerCase().indexOf(ql) === 0;
                  var note = v.state === 'stock' ? (v.available != null ? v.available + ' in stock' : 'In stock') : v.state === 'mto' ? 'Made to order' : 'Sold out';
                  return '<div class="wh-size is-' + v.state + '"' + (hit ? ' style="outline:2px solid var(--COLOR-ACCENT)"' : '') + '><label for="WhQr-' + v.id + '">' + esc(v.size) + '</label><input id="WhQr-' + v.id + '" type="number" min="0" step="1" inputmode="numeric" placeholder="0"' + (v.state === 'off' ? ' disabled' : '') + ' data-id="' + v.id + '" aria-describedby="WhQrN-' + v.id + '"><small id="WhQrN-' + v.id + '">' + note + '</small></div>';
                }).join('') + '</div>';
              }).join('') +
              '</div><button type="button" class="wh-btn wh-btn--small" data-wh-qr-add="' + esc(p.handle) + '">Add</button></div>';
          }).join('');
          qResults._data = rs;
        }).catch(function () {
          if (seq !== qSeq) return;
          qResults.innerHTML = '<p style="padding:12px">Search isn\'t available right now. Please try again, or <a href="/collections/all?view=wholesale">browse the catalog</a>.</p>';
        });
      }, 300);
    });
    qResults.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wh-qr-add]'); if (!b) return;
      var p = (qResults._data || []).find(function (x) { return x.handle === b.dataset.whQrAdd; });
      var row = b.closest('.wh-result');
      var added = 0, bad = false;
      row.querySelectorAll('input[data-id]').forEach(function (inp) {
        var v = inp.value.trim(); if (!v) return;
        if (!/^\d+$/.test(v)) { inp.setAttribute('aria-invalid', 'true'); bad = true; return; }
        var q = Number(v); if (!q) return;
        var variant = p.variants.find(function (x) { return String(x.id) === inp.dataset.id; });
        Sheet.add(lineFromVariant(p, variant, q)); added += q; inp.value = '';
      });
      if (bad) { toast('Quantities must be whole numbers'); return; }
      if (!added) { toast('Enter a quantity for at least one size'); return; }
      productVariants[p.handle] = p.variants;
      Sheet.save(); render(); toast('Added ' + added + ' units of ' + p.title);
      track('quick_add', { handle: p.handle, units: added });
    });

    // CSV import
    var csvInput = root.querySelector('[data-wh-csv]');
    var csvReport = root.querySelector('[data-wh-csv-report]');
    root.querySelector('[data-wh-csv-template]').addEventListener('click', function () {
      var sample = Sheet.data.lines.length
        ? Sheet.data.lines.map(function (l) { return (l.sku || '') + ',' + l.qty; }).join('\n')
        : 'NBA-401-BUL-S,1\nNBA-401-BUL-M,2\nNBA-401-BUL-L,2\nNBA-401-BUL-XL,1';
      var blob = new Blob(['sku,quantity\n' + sample + '\n'], { type: 'text/csv' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = 'jeff-hamilton-wholesale-order.csv';
      document.body.appendChild(a); a.click(); a.remove();
    });
    function parseCSV(text) {
      var rows = [], row = [], cell = '', q = false;
      text = text.replace(/^﻿/, '');
      for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (q) { if (c === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else q = false; } else cell += c; }
        else if (c === '"') q = true;
        else if (c === ',' || c === ';' || c === '\t') { row.push(cell); cell = ''; }
        else if (c === '\n' || c === '\r') { if (c === '\r' && text[i + 1] === '\n') i++; row.push(cell); rows.push(row); row = []; cell = ''; }
        else cell += c;
      }
      if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
      return rows.filter(function (r) { return r.some(function (x) { return x.trim() !== ''; }); });
    }
    csvInput.addEventListener('change', function () {
      var file = csvInput.files[0]; if (!file) return;
      if (file.size > 512000) { csvReport.innerHTML = '<p class="wh-error">That file is too large. Keep it under 500 KB (about 10,000 rows).</p>'; return; }
      csvReport.innerHTML = '<p class="wh-muted">Reading ' + esc(file.name) + '…</p>';
      file.text().then(function (text) {
        var rows = parseCSV(text);
        var start = 0, skuCol = 0, qtyCol = 1;
        if (rows.length && /sku/i.test(rows[0].join(' '))) {
          rows[0].forEach(function (h, i) { if (/sku/i.test(h)) skuCol = i; if (/qty|quant/i.test(h)) qtyCol = i; });
          start = 1;
        }
        var errors = [], wanted = {};
        rows.slice(start).forEach(function (r, i) {
          var n = i + start + 1;
          var sku = (r[skuCol] || '').trim(), raw = (r[qtyCol] || '').trim();
          if (!sku) { errors.push('Row ' + n + ': missing SKU'); return; }
          if (!/^\d+$/.test(raw) || Number(raw) === 0) { errors.push('Row ' + n + ' (' + sku + '): quantity must be a whole number above 0, got “' + raw + '”'); return; }
          var k = sku.toLowerCase();
          if (wanted[k]) { wanted[k].qty += Number(raw); wanted[k].rows.push(n); } else wanted[k] = { sku: sku, qty: Number(raw), rows: [n] };
        });
        var keys = Object.keys(wanted);
        if (!keys.length) { csvReport.innerHTML = '<p class="wh-error">No usable rows found.</p>' + (errors.length ? '<ul>' + errors.map(function (e) { return '<li>' + esc(e) + '</li>'; }).join('') + '</ul>' : ''); return; }
        if (keys.length > 400) { csvReport.innerHTML = '<p class="wh-error">Please upload 400 SKUs or fewer at a time.</p>'; return; }
        var matched = 0, units = 0, done = 0, queue = keys.slice();
        csvReport.innerHTML = '<p class="wh-muted" data-wh-csv-progress>Matching ' + keys.length + ' SKUs…</p>';
        var worker = function () {
          var k = queue.shift(); if (!k) return Promise.resolve();
          var w = wanted[k];
          return searchProducts(w.sku).then(function (rs) {
            var hit = null, prod = null;
            rs.forEach(function (p) { p.variants.forEach(function (v) { if (!hit && v.sku && v.sku.toLowerCase() === k) { hit = v; prod = p; } }); });
            if (!hit) { errors.push('Row ' + w.rows.join(', ') + ' (' + w.sku + '): SKU not found'); return; }
            if (prod.excluded || hit.state === 'off') { errors.push('Row ' + w.rows.join(', ') + ' (' + w.sku + '): ' + prod.title + ' ' + hit.size + ' is sold out or not offered wholesale'); return; }
            Sheet.add(lineFromVariant(prod, hit, w.qty)); productVariants[prod.handle] = prod.variants;
            matched++; units += w.qty;
            if (w.rows.length > 1) errors.push('Rows ' + w.rows.join(', ') + ' (' + w.sku + '): duplicate SKU, quantities combined to ' + w.qty);
          }).catch(function () { errors.push('Row ' + w.rows.join(', ') + ' (' + w.sku + '): lookup failed, try again'); })
            .then(function () { done++; var p = csvReport.querySelector('[data-wh-csv-progress]'); if (p) p.textContent = 'Matching SKUs… ' + done + ' of ' + keys.length; })
            .then(worker);
        };
        Promise.all([worker(), worker(), worker()]).then(function () {
          Sheet.save(); render();
          csvReport.innerHTML = '<p class="' + (errors.length ? '' : 'wh-muted') + '"><strong>' + matched + ' of ' + keys.length + ' SKUs added (' + units + ' units).</strong></p>' +
            (errors.length ? '<ul>' + errors.map(function (e) { return '<li>' + esc(e) + '</li>'; }).join('') + '</ul>' : '');
          csvInput.value = '';
          track('csv_import', { skus: keys.length, matched: matched });
        });
      }).catch(function () { csvReport.innerHTML = '<p class="wh-error">We couldn\'t read that file. Save it as CSV and try again.</p>'; });
    });

    // Saved lists (this browser)
    var listItems = root.querySelector('[data-wh-list-items]');
    function renderLists() {
      var lists = store.get('localStorage', LISTS, []);
      listItems.innerHTML = lists.length ? lists.map(function (l, i) {
        var u = l.lines.reduce(function (s, x) { return s + x.qty; }, 0);
        return '<li style="justify-content:space-between;flex-wrap:wrap"><span><strong>' + esc(l.name) + '</strong> · ' + u + ' units · saved ' + new Date(l.at).toLocaleDateString() + '</span><span><button type="button" class="wh-link-btn" data-wh-list-load="' + i + '">Load</button> · <button type="button" class="wh-link-btn" data-wh-list-del="' + i + '">Delete</button></span></li>';
      }).join('') : '<li class="wh-muted">No saved lists yet.</li>';
    }
    root.querySelector('[data-wh-list-save]').addEventListener('click', function () {
      var nameEl = root.querySelector('[data-wh-list-name]');
      var name = nameEl.value.trim();
      if (!Sheet.data.lines.length) { toast('Add something to the sheet before saving a list'); return; }
      if (!name) { nameEl.setAttribute('aria-invalid', 'true'); nameEl.focus(); toast('Name the list first'); return; }
      nameEl.removeAttribute('aria-invalid');
      var lists = store.get('localStorage', LISTS, []).filter(function (l) { return l.name.toLowerCase() !== name.toLowerCase(); });
      lists.unshift({ name: name, at: Date.now(), lines: Sheet.data.lines.map(function (l) { return { id: l.id, handle: l.handle, qty: l.qty, product: l.product, size: l.size, group: l.group, sku: l.sku, unit: l.unit, retail: l.retail, state: l.state, image: l.image, variant: l.variant }; }) });
      store.set('localStorage', LISTS, lists.slice(0, 20)); nameEl.value = ''; renderLists(); toast('Saved “' + name + '”');
    });
    listItems.addEventListener('click', function (e) {
      var lists = store.get('localStorage', LISTS, []);
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.whListLoad != null) {
        var l = lists[Number(b.dataset.whListLoad)]; if (!l) return;
        if (Sheet.data.lines.length && !window.confirm('Add “' + l.name + '” to the lines already on your sheet?')) return;
        l.lines.forEach(function (x) { Sheet.add(Object.assign({}, x)); });
        Sheet.save(); refresh(); toast('Loaded “' + l.name + '”');
      } else if (b.dataset.whListDel != null) {
        lists.splice(Number(b.dataset.whListDel), 1); store.set('localStorage', LISTS, lists); renderLists();
      }
    });
    renderLists();

    // Submit
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      var t = totals();
      var blocking = checks(t).filter(function (c) { return !c.ok && c.level === 'err'; });
      if (!t.units) blocking = [{ text: 'Add at least one style to your order sheet' }];
      if (refreshState === 'running') blocking.push({ text: 'Wait a moment while we recheck stock and prices' });
      if (blocking.length) {
        e.preventDefault();
        errBox.hidden = false;
        errBox.querySelector('ul').innerHTML = blocking.map(function (c) { return '<li>' + esc(c.text) + '</li>'; }).join('');
        errBox.focus();
        track('order_request_blocked', { reasons: blocking.length });
        return;
      }
      if (submitBtn.dataset.sending === 'true') { e.preventDefault(); return; }
      var hist = store.get('localStorage', HISTORY, []);
      if (hist.some(function (h) { return h.ref === Sheet.data.ref; })) Sheet.data.ref = makeRef('WO');
      var txt = [];
      Object.keys(t.byStyle).forEach(function (h) {
        var ls = t.byStyle[h];
        txt.push('■ ' + ls[0].product + ' (' + ls.reduce(function (s, l) { return s + l.qty; }, 0) + ' units)');
        ls.forEach(function (l) {
          txt.push('   ' + (l.group ? l.group + ' / ' : '') + (l.size || l.variant) + ' · SKU ' + (l.sku || 'n/a') + ' · variant ' + l.id + ' · ' + l.qty + ' × ' + money(l.unit) + ' = ' + money(l.qty * l.unit) + (l.state === 'mto' ? ' · MADE TO ORDER' : l.available != null && l.qty > l.available ? ' · EXCEEDS STOCK (' + l.available + ')' : ''));
        });
      });
      var set = function (k, v) { form.querySelector('[data-wh-field="' + k + '"]').value = v; };
      set('ref', Sheet.data.ref);
      set('lines', '\n' + txt.join('\n'));
      set('totals', t.styles + ' styles · ' + t.units + ' units · wholesale subtotal ' + money(t.subtotal) + ' · suggested retail ' + money(t.retail) + ' · shipping and tax to be added on invoice');
      set('csv', '\nsku,variant_id,quantity\n' + Sheet.data.lines.map(function (l) { return (l.sku || '') + ',' + l.id + ',' + l.qty; }).join('\n'));
      store.set('sessionStorage', 'jhwh:pending-order', { ref: Sheet.data.ref, at: Date.now(), units: t.units, styles: t.styles, subtotal: t.subtotal, po: Sheet.data.fields.po || '' });
      Sheet.save();
      submitBtn.dataset.sending = 'true';
      submitBtn.classList.add('is-loading');
      submitBtn.setAttribute('aria-busy', 'true');
    });

    // Reorder hand-off from the account page
    var incoming = store.get('sessionStorage', 'jhwh:reorder', null);
    if (incoming) {
      store.del('sessionStorage', 'jhwh:reorder');
      changesEl.hidden = false;
      changesEl.innerHTML = '<p>Loaded ' + incoming.count + ' line' + (incoming.count === 1 ? '' : 's') + ' from order ' + esc(incoming.name) + '. We\'re rechecking today\'s stock and prices now.</p>';
    }
    render();
    refresh();
  }

  /* ---------- Account page ---------- */
  document.querySelectorAll('[data-wh-reorder]').forEach(function (b) {
    b.addEventListener('click', function () {
      var items;
      try { items = JSON.parse(b.dataset.whReorder); } catch (e) { items = []; }
      items = items.filter(function (i) { return i.handle; });
      if (!items.length) { toast('Those products are no longer available to reorder'); return; }
      if (Sheet.data.lines.length && !window.confirm('Your order sheet already has items. Add order ' + b.dataset.whReorderName + ' to it?')) return;
      items.forEach(function (i) {
        Sheet.add({ id: i.id, handle: i.handle, product: i.handle.replace(/-/g, ' '), qty: i.qty, unit: i.unit, origUnit: i.unit, retail: i.unit * 2, state: 'stock', source: 'order ' + b.dataset.whReorderName });
      });
      Sheet.save();
      store.set('sessionStorage', 'jhwh:reorder', { name: b.dataset.whReorderName, count: items.length });
      track('reorder_started', { order: b.dataset.whReorderName });
      window.location.href = '/pages/wholesale-order';
    });
  });
  var histEl = document.querySelector('[data-wh-history]');
  if (histEl) {
    var hist = store.get('localStorage', HISTORY, []);
    if (hist.length) histEl.innerHTML = '<ul class="wh-checklist">' + hist.slice(0, 8).map(function (h) {
      return '<li class="is-ok"><span><strong>' + esc(h.ref) + '</strong> · ' + new Date(h.at).toLocaleDateString() + ' · ' + h.units + ' units · ' + money(h.subtotal) + (h.po ? ' · PO ' + esc(h.po) : '') + '</span></li>';
    }).join('') + '</ul><p class="wh-muted" style="font-size:13px">Requests become orders above once invoiced.</p>';
  }
  var savedEl = document.querySelector('[data-wh-saved-lists]');
  if (savedEl) {
    var ls = store.get('localStorage', LISTS, []);
    if (ls.length) savedEl.innerHTML = '<ul class="wh-checklist">' + ls.slice(0, 8).map(function (l) {
      return '<li><span><strong>' + esc(l.name) + '</strong> · ' + l.lines.reduce(function (s, x) { return s + x.qty; }, 0) + ' units</span></li>';
    }).join('') + '</ul><p><a href="/pages/wholesale-order">Open on the order sheet</a></p>';
  }

  /* ---------- Application form ---------- */
  var app = document.getElementById('WholesaleApplication');
  if (app) initApplication(app);

  function initApplication(form) {
    var success = form.querySelector('[data-wh-apply-success]');
    var DRAFT = 'jhwh:app-draft';
    var APPLIED = 'jhwh:applied';
    if (success) {
      var pending = store.get('sessionStorage', 'jhwh:pending-app', null);
      if (pending) {
        var refEl = success.querySelector('[data-wh-app-ref]');
        if (refEl) refEl.textContent = pending.ref;
        var applied = store.get('localStorage', APPLIED, []);
        applied.unshift(pending);
        store.set('localStorage', APPLIED, applied.slice(0, 10));
        store.del('sessionStorage', 'jhwh:pending-app');
        track('application_submitted', { ref: pending.ref, type: pending.type });
      }
      store.del('sessionStorage', DRAFT);
      return;
    }
    if (!form.querySelector('[data-wh-submit]')) return;
    form.setAttribute('novalidate', '');
    var fields = form.querySelectorAll('input:not([type=hidden]):not([data-wh-honeypot]), select, textarea');

    // Restore an unsent draft (e.g. after a server error)
    var draft = store.get('sessionStorage', DRAFT, null);
    if (draft) fields.forEach(function (f) {
      if (!(f.name in draft)) return;
      if (f.type === 'checkbox') f.checked = !!draft[f.name];
      else if (!f.value || f.defaultValue === f.value) f.value = draft[f.name];
    });
    var saveDraft = function () {
      var d = {};
      fields.forEach(function (f) { d[f.name] = f.type === 'checkbox' ? f.checked : f.value; });
      store.set('sessionStorage', DRAFT, d);
    };
    form.addEventListener('input', saveDraft);
    form.addEventListener('change', saveDraft);

    var started = false;
    form.addEventListener('focusin', function () { if (!started) { started = true; track('application_started'); } });

    var summary = form.querySelector('[data-wh-error-summary]');
    var dupBox = form.querySelector('[data-wh-duplicate]');
    var dupConfirmed = false;
    var msgFor = function (f) {
      var label = (form.querySelector('label[for="' + f.id + '"]') || {}).textContent || f.name;
      label = label.replace('*', '').trim();
      if (f.type === 'checkbox') return 'Please confirm: ' + label.split('.')[0];
      if (f.validity.valueMissing) return 'Enter ' + label.toLowerCase();
      if (f.type === 'email') return 'Enter a valid email address, like name@store.com';
      return 'Check ' + label.toLowerCase();
    };
    var validate = function () {
      var errs = [];
      fields.forEach(function (f) {
        var err = document.getElementById(f.id + '-err');
        f.removeAttribute('aria-invalid');
        if (err) err.textContent = '';
        var bad = !f.checkValidity();
        if (!bad && f.type === 'tel' && f.value && f.value.replace(/\D/g, '').length < 7) bad = true;
        if (!bad && f.type === 'email' && f.value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value)) bad = true;
        if (bad) {
          var m = f.type === 'tel' ? 'Enter a phone number with area code' : msgFor(f);
          f.setAttribute('aria-invalid', 'true');
          if (err) err.textContent = m;
          errs.push({ id: f.id, msg: m });
        }
      });
      form.querySelectorAll('[data-wh-group-required]').forEach(function (g) {
        var id = g.dataset.whGroupRequired;
        var any = g.querySelector('input:checked');
        var err = document.getElementById(id + '-err');
        if (err) err.textContent = any ? '' : 'Choose at least one';
        if (!any) errs.push({ id: g.querySelector('input').id || id, msg: 'Choose at least one place you sell', el: g.querySelector('input') });
      });
      return errs;
    };
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('[data-wh-honeypot]');
      if (hp && hp.value) { e.preventDefault(); return; }
      var errs = validate();
      if (errs.length) {
        e.preventDefault();
        summary.hidden = false;
        summary.querySelector('ul').innerHTML = errs.map(function (x, i) { return '<li><a href="#' + esc(x.id) + '" data-i="' + i + '">' + esc(x.msg) + '</a></li>'; }).join('');
        summary.focus();
        summary.onclick = function (ev) {
          var a = ev.target.closest('a'); if (!a) return;
          ev.preventDefault();
          var x = errs[Number(a.dataset.i)];
          var target = x.el || document.getElementById(x.id);
          if (target) target.focus();
        };
        track('application_invalid', { errors: errs.length });
        return;
      }
      summary.hidden = true;
      var email = (form.querySelector('[name="contact[email]"]').value || '').trim().toLowerCase();
      var prior = store.get('localStorage', APPLIED, []).find(function (a) { return a.email === email && Date.now() - a.at < 60 * 86400000; });
      if (prior && !dupConfirmed) {
        e.preventDefault();
        dupConfirmed = true;
        dupBox.hidden = false;
        dupBox.querySelector('[data-wh-duplicate-date]').textContent = new Date(prior.at).toLocaleDateString();
        dupBox.focus();
        return;
      }
      var btn = form.querySelector('[data-wh-submit]');
      if (btn.dataset.sending === 'true') { e.preventDefault(); return; }
      var ref = makeRef('WA');
      form.querySelector('[data-wh-app-ref-input]').value = ref + (prior ? ' (update to an earlier application)' : '');
      store.set('sessionStorage', 'jhwh:pending-app', { ref: ref, email: email, at: Date.now(), type: (form.querySelector('[name="contact[Business type]"]') || {}).value });
      btn.dataset.sending = 'true';
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    });
  }

  updateCounts();
})();
